// export const blogTemplate = {
//   title: "Your Blog Post Title",
//   content: `
//     <div class="blogHero">
//       <div class="container">
//         <div class="heroContent">
//           <div type="blogTitle" data-type="blog-title" class="blogTitle">Your Blog Post Title</div>
//           <div type="blogMeta" data-type="blog-meta" class="blogMeta">
//             <div type="blogDate" data-type="blog-date" class="date">${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
//             <div type="blogCategory" data-type="blog-category" class="category">Category</div>
//           </div>
//         </div>
//         <hr />
//       </div>
//     </div>

//     <div class="container">
//       <div class="blogContent">
//         <h2>Introduction</h2>
//         <p>Start your blog post with an engaging introduction that captures your readers' attention. Explain what they'll learn from this post and why it matters to them.</p>

//         <h2>Text Formatting</h2>
//         <p>This section demonstrates various text formatting options available in the editor:</p>
//         <ul>
//           <li><strong>Bold text</strong> for emphasis</li>
//           <li><em>Italic text</em> for subtle emphasis</li>
//           <li><u>Underlined text</u> for important points</li>
//           <li><s>Strikethrough text</s> for outdated information</li>
//           <li><mark>Highlighted text</mark> for key concepts</li>
//         </ul>

//         <h2>Text Colors</h2>
//         <p>You can use different text colors to create visual hierarchy:</p>
//         <ul>
//           <li><span style="color: #07587f">Blue text</span> for primary content</li>
//           <li><span style="color: #09293B">Dark text</span> for strong emphasis</li>
//           <li><span style="color: rgba(7, 88, 127, 0.1)">Light text</span> for subtle information</li>
//           <li><span style="color: #FFFFFF; background: #333; padding: 2px 4px; border-radius: 4px;">White text</span> for contrast</li>
//         </ul>

//         <h2>Text Alignment</h2>
//         <p style="text-align: left">Left-aligned text is the default and works well for most content.</p>
//         <p style="text-align: center">Center-aligned text is great for quotes and callouts.</p>
//         <p style="text-align: right">Right-aligned text can be used for dates or signatures.</p>
//         <p style="text-align: justify">Justified text creates clean edges on both sides, ideal for formal documents.</p>

//         <h2>Lists and Organization</h2>
//         <h3>Bullet Lists</h3>
//         <ul>
//           <li>First item in an unordered list</li>
//           <li>Second item with nested content
//             <ul>
//               <li>Nested bullet point</li>
//               <li>Another nested point</li>
//             </ul>
//           </li>
//           <li>Third item in the main list</li>
//         </ul>

//         <h3>Numbered Lists</h3>
//         <ol>
//           <li>First step in a process</li>
//           <li>Second step with nested content
//             <ol>
//               <li>Sub-step one</li>
//               <li>Sub-step two</li>
//             </ol>
//           </li>
//           <li>Final step in the process</li>
//         </ol>

//         <h2>Blockquotes and Code</h2>
//         <blockquote>
//           <p>This is a blockquote that can be used to highlight important quotes or key takeaways from your content. It's styled with a left border and subtle background for visual distinction.</p>
//         </blockquote>

//         <h3>Code Blocks</h3>
//         <pre><code>// This is a code block
// function example() {
//   console.log("Code blocks are great for technical content");
//   return true;
// }</code></pre>

//         <h2>Tables</h2>
//         <p>Tables are perfect for organizing structured data:</p>
//         <table>
//           <thead>
//             <tr>
//               <th>Feature</th>
//               <th>Description</th>
//               <th>Usage</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>Headers</td>
//               <td>Table headers with distinct styling</td>
//               <td>For column labels</td>
//             </tr>
//             <tr>
//               <td>Rows</td>
//               <td>Interactive row manipulation</td>
//               <td>Add/remove/merge rows</td>
//             </tr>
//             <tr>
//               <td>Columns</td>
//               <td>Column management tools</td>
//               <td>Add/remove/merge columns</td>
//             </tr>
//           </tbody>
//         </table>

//         <h2>Images and Media</h2>
//         <p>You can add images to enhance your content:</p>
//         <img src="https://via.placeholder.com/800x400" alt="Example image" />

//         <h2>Links</h2>
//         <p>Add <a href="#">hyperlinks</a> to connect your content with other resources.</p>

//         <h2>Horizontal Rules</h2>
//         <p>Use horizontal rules to separate content sections:</p>
//         <hr />

//         <h2>Conclusion</h2>
//         <p>Wrap up your blog post with a strong conclusion that summarizes the key takeaways and provides a clear next step for your readers.</p>

//         <blockquote>
//           <p>Remember to use these formatting tools thoughtfully to create engaging, well-structured content that aligns with your brand's visual identity.</p>
//         </blockquote>
//       </div>
//     </div>
//   `
// }; 

export const blogTemplate = {
  title: "Your Blog Post Title",
  content: `
    <div class="blogHero">
      <div class="container">
        <div class="heroContent">
          <div type="blogTitle" data-type="blog-title" class="blogTitle">Your Blog Post Title</div>
          <div type="blogMeta" data-type="blog-meta" class="blogMeta">
            <div type="blogDate" data-type="blog-date" class="date">${new Date().toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}</div>
            <div type="blogCategory" data-type="blog-category" class="category">Category</div>
          </div>
        </div>
        <hr />
      </div>
    </div>

    <div class="container">
      <div class="blogContent">
        <h2>Performance Redefined</h2>
        <p><strong>At WebNX</strong>, we’re setting the standard again. Our <span style="color:#07587f">Zen 5 Ryzen servers</span> with <mark>256GB of RAM</mark> are built for clients who demand maximum power and flexibility.</p>

        <blockquote>
          <p>“Speed, reliability, and efficiency—our new servers offer it all.”</p>
        </blockquote>

        <h3 style="border-left: 4px solid #07587f; padding-left: 10px;">Built for the Future</h3>
        <ul>
          <li><strong>16-Core</strong> Ryzen 9 9950X processor</li>
          <li><em>5.8GHz Boost Clock</em> for demanding workloads</li>
          <li><u>256GB DDR5 RAM</u> for large-scale apps</li>
          <li><s>Outdated bottlenecks</s> eliminated</li>
        </ul>

        <p style="text-align: center;"><span style="color:#09293B">Whether you're building a gaming platform, AI system, or enterprise database—we’ve got your back.</span></p>

        <pre><code>// Benchmark results
const cpu = "Ryzen 9 9950X";
const score = "Cinebench R23: ~45,000";
console.log(\`\${cpu} scores \${score}\`);
</code></pre>

        <h3>Benchmark Summary</h3>
        <table>
          <thead>
            <tr><th>CPU</th><th>Cores/Threads</th><th>Boost</th><th>Score</th></tr>
          </thead>
          <tbody>
            <tr><td>Ryzen 9 9950X</td><td>16/32</td><td>5.8GHz</td><td>~45,000</td></tr>
            <tr><td>Intel i9-14900K</td><td>24/32</td><td>6.0GHz</td><td>~41,000</td></tr>
          </tbody>
        </table>

        <hr />

        <h2 style="text-align:right;">Ready to Deploy?</h2>
        <p style="text-align:right;">Contact us to customize your build and <a href="#">secure your Ryzen server today</a>.</p>
      </div>
    </div>
  `,
};
